var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-4" },
    [
      _c("modal-filter", {
        attrs: {
          onfilter: _vm.onfilter,
          filter: _vm.filter,
          exclude: ["state_id", "payment_state_id"],
        },
        on: {
          onclose: function ($event) {
            _vm.onfilter = false
          },
          onfilter: function ($event) {
            return _vm.ONFILTER()
          },
        },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "vstack gap-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column flex-md-row gap-3 justify-content-between",
              },
              [
                _c(
                  "form",
                  {
                    staticClass: "d-flex gap-3 row",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.FILTER()
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.onfilter = true
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-funnel me-2" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Filtro")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "vr opacity-20 mx-3" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-xs text-primary" }, [
                            _vm._v(_vm._s(_vm.count_filter)),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.SORT()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "me-2",
                            class:
                              _vm.filter.sortDesc == "ASC"
                                ? "bi bi-sort-alpha-up"
                                : "bi bi-sort-alpha-down-alt",
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.filter.sortDesc))]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 px-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "input-group input-group-sm input-group-inline",
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.search,
                                expression: "filter.search",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", placeholder: "Buscar..." },
                            domProps: { value: _vm.filter.search },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filter,
                                  "search",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-primary",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm.loading == "filter"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Buscar")]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.CLEAR()
                            },
                          },
                        },
                        [
                          _vm.loading == "clear"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Limpiar")]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.globalViewOption("WarehouseAsigned")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column flex-md-row gap-3 justify-content-between",
                  },
                  [
                    _c("div", { staticClass: "d-flex gap-3 row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-3 px-0" },
                        [
                          _c("v-combobox", {
                            staticClass: "form-control form-control-sm",
                            attrs: {
                              items: _vm.awbs,
                              "item-text": "awb",
                              "item-value": "awb",
                              "search-input": _vm.search_awbs,
                              "hide-details": "",
                              placeholder: "Seleccione o ingrese AWB...",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.search_awbs = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.search_awbs = $event
                              },
                              change: _vm.CHANGE_AWB,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "no-data",
                                  fn: function () {
                                    return [
                                      _c("v-list-item", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.loading == "awbs"
                                                ? "Buscando..."
                                                : "No hay datos disponibles"
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1035313393
                            ),
                            model: {
                              value: _vm.form.awb,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "awb", $$v)
                              },
                              expression: "form.awb",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-3 px-0" },
                        [
                          _c("v-combobox", {
                            staticClass: "form-control form-control-sm",
                            attrs: {
                              items: _vm.hawbs,
                              "item-text": "hawb",
                              "item-value": "hawb",
                              "search-input": _vm.search_hawbs,
                              "hide-details": "",
                              placeholder: "Seleccione o ingrese HAWB...",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.search_hawbs = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.search_hawbs = $event
                              },
                              change: _vm.CHANGE_HAWB,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "no-data",
                                  fn: function () {
                                    return [
                                      _c("v-list-item", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.loading == "hawbs"
                                                ? "Buscando..."
                                                : "No hay datos disponibles"
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1934845625
                            ),
                            model: {
                              value: _vm.form.hawb,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hawb", $$v)
                              },
                              expression: "form.hawb",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-h px-3 btn-success",
                            attrs: { type: "button" },
                            on: { click: _vm.ASIGNED },
                          },
                          [_c("span", [_vm._v("Asignar")])]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body p-0" },
                [
                  [
                    _c("v-data-table", {
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.headers,
                        items:
                          _vm.loading == "table" ||
                          _vm.loading == "sort" ||
                          _vm.loading == "filter" ||
                          _vm.loading == "clear"
                            ? []
                            : _vm.items.data,
                        "show-select": _vm.globalViewOption("WarehouseAsigned"),
                        options: _vm.options,
                        "server-items-length": _vm.items.total,
                        loading:
                          _vm.loading == "table" ||
                          _vm.loading == "sort" ||
                          _vm.loading == "filter" ||
                          _vm.loading == "clear",
                        "footer-props": {
                          "items-per-page-options": [5, 10, 50, 100],
                        },
                      },
                      on: {
                        "update:options": function ($event) {
                          _vm.options = $event
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.data-table-select",
                            fn: function (ref) {
                              var item = ref.item
                              var isSelected = ref.isSelected
                              var select = ref.select
                              return [
                                _c("v-simple-checkbox", {
                                  attrs: { ripple: false, value: isSelected },
                                  on: {
                                    input: function ($event) {
                                      return select($event)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "item.id",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(item.type) +
                                    _vm._s(item.id) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.pieces",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      Number(item.pieces || 0).toFixed(2)
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.lengthy",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      Number(item.lengthy || 0).toFixed(2)
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.width",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(Number(item.width || 0).toFixed(2)) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.tall",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(Number(item.tall || 0).toFixed(2)) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.weight",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      Number(item.weight || 0).toFixed(2)
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.state.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "badge badge-pill",
                                    class: item.state.labels
                                      ? item.state.labels
                                      : "badge-light",
                                  },
                                  [_vm._v(_vm._s(item.state.name))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.description",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    staticClass: "mx-1",
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              Array.isArray(item.description)
                                                ? _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass: "nowrap",
                                                        },
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.description[0]
                                                          ) +
                                                          " ...\n                                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      _vm._l(
                                        item.description,
                                        function (description, key) {
                                          return _c("div", { key: key }, [
                                            _vm._v(_vm._s(description)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.created_at",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm._f("DATE")(item.created_at)) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.actions",
                            fn: function (ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex gap-3" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-neutral btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.PRINT_WAREHOUSE(
                                                                item.id,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                        },
                                                        [
                                                          _vm.print_wr.filter(
                                                            function (e) {
                                                              return e == index
                                                            }
                                                          ).length == 1
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "spinner-border spinner-border-sm mb-0",
                                                                  attrs: {
                                                                    role: "status",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Loading..."
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("i", {
                                                                staticClass:
                                                                  "bi bi-printer",
                                                              }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v(
                                            "Imprimir Certificado de depósito"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-danger btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.PRINT_TAG(
                                                                item.id,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                        },
                                                        [
                                                          _vm.print_tag.filter(
                                                            function (e) {
                                                              return e == index
                                                            }
                                                          ).length == 1
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "spinner-border spinner-border-sm mb-0",
                                                                  attrs: {
                                                                    role: "status",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Loading..."
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("i", {
                                                                staticClass:
                                                                  "bi bi-printer",
                                                              }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Imprimir TAG")]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.form.selected,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "selected", $$v)
                        },
                        expression: "form.selected",
                      },
                    }),
                  ],
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Bodega")]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _c("i", { staticClass: "bi bi-search" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Listado")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }